import { useEffect, useState } from 'react';
import { useUnit } from 'effector-react';
import { $paymentsByRecipientId } from '@lib/store/payments/getPaymentRecipientByIdStore';
import type { RecipientResponse } from '@shared/api/rest/recipients';
import { RecipientTable } from './recipientTable';

interface IListProps {
  data: RecipientResponse;
}

export const RecipientTransaction = (props: IListProps) => {
  const paymentsByRecipientId = useUnit($paymentsByRecipientId.store);

  const [index, setIndex] = useState<number>(1);
  const [count, setCount] = useState<number>(10);

  useEffect(() => {
    if (!props.data.id) return;
    $paymentsByRecipientId.events.update({
      RecipientId: props.data.id,
      Count: count,
      FromIndex: (index - 1) * count,
    });
  }, [count, index, props.data?.id]);

  return (
    <RecipientTable
      data={paymentsByRecipientId.data?.data}
      currentPage={index}
      totalItemCount={paymentsByRecipientId.data.total}
      countItemPage={count}
      onChangePage={setIndex}
      onChangeCountItemPage={setCount}
      isLoading={paymentsByRecipientId.loading}
    />
  );
};
